import ChatRepository from "../domain/data/ChatRepository";
import { PostComment } from "../domain/entities/Chat";
import AwsApiClient from "../presentation/hooks/AwsApiClient";

export default class APIChatRepository implements ChatRepository {
  private client = new AwsApiClient();

  async saveChat(
    campaignId: string,
    signatoryEmail: string,
    postComment: PostComment
  ): Promise<PostComment> {
    try {
      const encodedSignatoryEmail = encodeURIComponent(signatoryEmail);
      const response = await this.client.postExternal(
        `/api/chat/${campaignId}/${encodedSignatoryEmail}`,
        postComment
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getChats(
    campaignId: string,
    signatoryEmail: string
  ): Promise<PostComment[]> {
    try {
      const encodedSignatoryEmail = encodeURIComponent(signatoryEmail);
      const response = await this.client.getExternal(
        `/api/chat/${campaignId}/${encodedSignatoryEmail}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getChatsExt(shortId: string): Promise<PostComment[]> {
    try {
      const response = await this.client.getExternal(
        `/api/ext/chat/${shortId}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async getAllChats(
    campaignIds: string[],
    signatoryEmail: string
  ): Promise<PostComment[]> {
    try {
      const encodedSignatoryEmail = encodeURIComponent(signatoryEmail);
      const response = await this.client.post(
        `/api/chat/all/${encodedSignatoryEmail}`,
        campaignIds,
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async deleteChat(
    campaignId: string,
    signatoryEmail: string,
    chatId: string
  ): Promise<boolean> {
    try {
      const encodedSignatoryEmail = encodeURIComponent(signatoryEmail);
      const response = await this.client.delete(
        `/api/chat/${campaignId}/${encodedSignatoryEmail}/${chatId}`,
        "none"
      );
      return true;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
